import React, { useEffect } from "react";
import { X } from "lucide-react";

export default function Modal({ open, onClose, title, eyebrow, children, maxWidth = "max-w-2xl" }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose?.();
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4"
      data-testid="modal-root"
      onClick={onClose}
    >
      <div className="absolute inset-0 bg-eduhu-dark/70 backdrop-blur-sm animate-in fade-in" />
      <div
        className={`relative ${maxWidth} w-full max-h-[90vh] bg-eduhu-bg2 border border-eduhu-border shadow-2xl overflow-hidden flex flex-col`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between p-6 lg:p-8 border-b border-eduhu-border">
          <div>
            {eyebrow && <div className="overline text-eduhu-claret mb-2">{eyebrow}</div>}
            <h3 className="font-serif text-2xl lg:text-3xl text-eduhu-dark tracking-tight">{title}</h3>
          </div>
          <button
            data-testid="modal-close"
            onClick={onClose}
            className="p-2 -m-2 hover:bg-eduhu-bg3 transition-colors"
            aria-label="Close"
          >
            <X size={20} strokeWidth={1.5} />
          </button>
        </div>
        <div className="overflow-y-auto p-6 lg:p-8 text-eduhu-inkSoft leading-relaxed">
          {children}
        </div>
      </div>
    </div>
  );
}
